import { useState } from 'react';

function useDefaultModal() {
  const [dataModal, setDataModal] = useState({
    show: false,
    type: '',
    message: '',
    onClose: null,
  });

  const showDefaultModal = (type, message, onClose = null) => {
    setDataModal({ show: true, type, message, onClose });
  };

  const closeDefaultModal = () => {
    setDataModal(prevModalData => {
      if (prevModalData.onClose && prevModalData.type === 'success') {
        prevModalData.onClose(); // Executa a ação apenas para mensagens de sucesso
      }
      return { ...prevModalData, show: false, onClose: null };
    });
  };

  return {
    setDefaultModal: {
      show: dataModal.show,
      type: dataModal.type,
      message: dataModal.message,
      onClose: closeDefaultModal,
    },
    showDefaultModal: showDefaultModal,
    show: dataModal.show,
    type: dataModal.type,
    message: dataModal.message,
    onClose: closeDefaultModal,
  };
}

export default useDefaultModal;
